import { LoadingButton as MuiLoadingButton } from '@mui/lab';

import { getLoadingPosition } from './utils';

import type { LoadingButtonProps } from '@mui/lab/LoadingButton';
import type { FC } from 'react';

export const LOADING_BUTTON_TEST_ID = 'loading-button';

export const LoadingButton: FC<LoadingButtonProps> = ({
  sx,
  loadingPosition: loadingPositionProp,
  loading,
  ...props
}) => {
  const loadingPosition = getLoadingPosition(loadingPositionProp, loading);

  return (
    <MuiLoadingButton
      {...props}
      loading={loading}
      loadingPosition={loadingPosition}
      data-testid={LOADING_BUTTON_TEST_ID}
      sx={{ textTransform: 'none', ...sx }}
    />
  );
};
